import { ResumePetisSimulationProposalClientResponse } from '../../@types/ResumePetisSimulationProposal'
import { AcceptConditionsClientResponse } from '../../@types/acceptConditions'
import { useAcceptConditionsStore } from '../../Stores/useAcceptConditionsStore'

export const useAcceptConditionsHydration = () => {
  const { setAcceptConditions } = useAcceptConditionsStore()

  const handleAcceptConditionsHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const acceptConditions = {
      ibanList: data.processData?.iBanData?.map((item) => item.iban),
      bankName: data.processData?.iBanData?.[0]?.bankName || '',
      isDirectDebit: data.processData?.proposalData?.isDirectDebit,
      // isPaperless
      // consentList
      // digitalDocumentationEmail
    } as AcceptConditionsClientResponse

    setAcceptConditions(acceptConditions)
  }

  return { handleAcceptConditionsHydration }
}
